module.exports = __webpack_public_path__ + "static/media/login.13d08eae.svg";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/login.svg
// module id = 474
// module chunks = 0